import shallow from 'zustand/shallow'
import useStore from '../store/useStore'

export default () => useStore(s => s.stages, shallow)
